export const getOptiHeaderText = (displayText: string): string => {
    switch (displayText) {
        case 'Shop by brand':
            return 'Brands';
        case 'Shop by pet':
            return 'Shop';
        case 'Pet Services':
            return 'Services';
        case 'Sale':
            return 'Deals';
        default:
            return displayText;
    }
};
